module.exports = __webpack_public_path__ + "img/bg2(1).de41dfe1.png";